function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2219 1994l-221 236m-97 104l-221 236m-398 59c39 0 71 32 71 71s-32 71-71 71H165c-46 0-87-19-117-49s-49-71-49-117V165c0-46 19-87 49-117S119-1 165-1h2030c46 0 87 19 117 49s49 71 49 117v1472c0 39-32 71-71 71s-71-32-71-71V165c0-6-3-12-7-16s-10-7-16-7H166c-6 0-12 3-16 7s-7 10-7 16v2440c0 6 3 12 7 16s10 7 16 7h1117zm-571-668c-39 0-71-32-71-72s32-72 71-72h462c39 0 71 32 71 72s-32 72-71 72H711zm0-1008c-39 0-71-32-71-71s32-71 71-71h938c39 0 71 32 71 71s-32 71-71 71H711zm0 503c-39 0-71-32-71-71s32-71 71-71h938c39 0 71 32 71 71s-32 71-71 71H711zm902 608c-29-27-30-72-4-100 27-29 72-30 100-4l236 221 221-236c27-29 72-30 100-4 29 27 30 72 4 100l-221 236 236 221c29 27 30 72 4 100-27 29-72 30-100 4l-236-221-221 236c-27 29-72 30-100 4-29-27-30-72-4-100l221-236-236-221z",
  fillRule: "nonzero"
});

var SvgDownloadEmpty = function SvgDownloadEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2361 2771",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download_empty.86d4e864.svg";
export { ForwardRef as ReactComponent };